module.exports = __webpack_public_path__ + "img/TEXT_WITH_SYMBOL.d8c3cc38.svg";